import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose, ExecutionResult } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import { createCmsContentVariables, createCmsContent } from '@api/graphql/types';
import CmsForm from '../components/CmsForm';
import Paths from '../paths';

type Props = {
} & InjectedIntlProps & RouteComponentProps;


interface State {
    formData: createCmsContentVariables;
}

class CmsCreate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                title: '',
                content: null,
                is_active: true,
                active_from: null,
                active_to: null,
                url_key: '',
                meta_title: null,
                meta_keywords: null,
                meta_description: null,
            },
        };
    }

    public onSubmit = (formData: createCmsContentVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.createCmsContent, variables: formData,
        });
    }

    private onRedirectFunction = (response: ExecutionResult<createCmsContent>) => {
        const id = response.data ? response.data.createCmsContent.id : undefined;
        if (id) {
            return `${Paths.cms}/${id}`;
        }
        return undefined;
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.cms.edit.title'})}</h5>
                        </div>
                        <div className="ibox-content">
                            {this.state.formData &&
                                <CmsForm formData={this.state.formData} onSubmit={this.onSubmit} redirectFunction={this.onRedirectFunction}/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(CmsCreate);



// WEBPACK FOOTER //
// ./src/modules/Cms/pages/CmsCreate.tsx